module.exports = __webpack_public_path__ + "img/lotery-rewards-4.67fd8265.jpg";